import { useGetAllGiveaways } from '@bpm-web-app/swr-hooks';
import ContestsGrid from '../contests-grid/contests-grid';
import styles from './past-contests.module.css';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface PastContestsProps { }

export function PastContests(props: PastContestsProps) {
    const { data, isLoading, error } = useGetAllGiveaways();

    if (isLoading || error) return <div />;

    return (
        <div className={styles['past-contests']}>
            <h2 className={styles['past-contests__title']}>Past Contests</h2>
            <div className={styles['past-contests__grid']}>
                <ContestsGrid contests={data.data.past} />
            </div>
        </div>
    );
}

export default PastContests;
